import React from 'react';
import { useImpersonation } from '../contexts/ImpersonationContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserSecret, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const ImpersonationBanner: React.FC = () => {
  const { impersonationState, endImpersonation } = useImpersonation();

  if (!impersonationState.isImpersonating) {
    return null;
  }

  return (
    <div className="bg-amber-500 text-white py-2 pl-4 md:pl-[270px] pr-4 flex items-center justify-between mb-4 lg:mb-0">
      <div className="flex items-center">
        <FontAwesomeIcon icon={faUserSecret} className="mr-2" />
        <span>
          You are impersonating a client. Any actions you take will be as the client.
        </span>
      </div>
      <button
        onClick={endImpersonation}
        className="bg-white text-amber-600 hover:bg-amber-100 px-3 py-1 rounded-md text-sm flex items-center"
      >
        <FontAwesomeIcon icon={faArrowLeft} className="mr-1" />
        Exit Impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner; 